import { createSlice } from "@reduxjs/toolkit";
import { solutionsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const solutionsSlice = createSlice({
  name: "solutions",
  initialState: data,
  reducers: {
    solutionsSlice(state) {
      state.isLoading = false;
    },
    solutionsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    solutionsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    solutionsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const solutionsHandler = () => async (dispatch: any) => {
  try {
    dispatch(solutionsAction.solutionsSlice());
    const response: any = await solutionsAPI();
    dispatch(solutionsAction.solutionsSliceSuccess(response));
  } catch (e: any) {
    dispatch(solutionsAction.solutionsSliceFailure(e?.response?.data?.message));
    dispatch(solutionsAction.solutionsSliceReset());
  }
};
export default solutionsSlice.reducer;
export const solutionsAction = solutionsSlice.actions;
